import React, { useEffect, useState } from "react";

import { Row, Col, Typography, Checkbox } from "antd";
interface Permission {
  id: number;
  operation: string;
  name?: string;
  isChecked?: boolean;
}
interface RoleCheckboxProps {
  name?: string;
  permissions: Permission[];
  onSelectedIdsChanged: (originalIds: number[], selectedIds: number[]) => void;
}
export const RoleCheckbox: React.FC<RoleCheckboxProps> = ({
  name,
  permissions,
  onSelectedIdsChanged,
}) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  useEffect(() => {
    let arr: number[] = [];
    permissions.forEach((permission) => {
      if (permission.isChecked) {
        arr.push(permission.id);
      }
      setSelectedIds(arr);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onSelectedIdsChanged(
      permissions.map((permission) => permission.id),
      selectedIds
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIds]);

  // const handleAllChecked = (e: React.SyntheticEvent, checked: boolean) => {
  //   if (checked) {
  //     const arr: number[] = [];
  //     permissions.forEach((permission) => {
  //       arr.push(permission.id);
  //     });
  //     setSelectedIds(arr);
  //   } else {
  //     setSelectedIds([]);
  //   }
  // };

  const checkIdExists = (id: number) => {
    return selectedIds.includes(id);
  };

  return (
    <>
      <Row>
        <Col>
          <Typography>{name}</Typography>
        </Col>
        <Col>
          {permissions?.map((permission: Permission) => {
            return (
              <Checkbox
                value={permission.id}
                checked={checkIdExists(permission.id)}
                key={permission.name}
                onChange={(checked: any) => {
                  if (checked) {
                    setSelectedIds([...selectedIds, permission.id]);
                  } else {
                    setSelectedIds(
                      selectedIds.filter((id) => id !== permission.id)
                    );
                  }
                }}
              >
                {permission.operation}
              </Checkbox>
            );
          })}
        </Col>
      </Row>
    </>
  );
};
